import { Component, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { AngularFireStorage } from '@angular/fire/storage';
import { UserserviceService } from '../../services/userservice.service';
@Component({
  selector: 'app-appfiles',
  templateUrl: './appfiles.component.html',
  styleUrls: ['./appfiles.component.scss']
})
export class AppfilesComponent implements OnInit {
  private _transformer = (node: any, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      url: node.url,
      level: level,
    };
  };

  treeControl = new FlatTreeControl<any>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(private afStorage: AngularFireStorage, private userService: UserserviceService) {
    this.dataSource.data = []



    /*
    dataPromise.push()


    Promise.all(dataPromise).then(d => {
      console.log("PROMISE ALL OK", currentData)
      this.dataSource.data.push(currentData)
    })*/
  }

  hasChild = (_: number, node: any) => node.expandable;


  manageModule():Promise<any> {
    let dataPromise = [];
    let currentData = []
    return new Promise<any>((resolve, reject) => {
      this.userService.getCurrentModules().then(d => {

     //   console.log(d);

        if (d.kiosk && !d.media)
          dataPromise.push(this.getListFiles('/app/kiosk', 'Kiosk').then(d => {
            currentData.push(d);
          }))

        if (d.media)
          dataPromise.push(this.getListFiles('/app/media', 'Média').then(d => {
            currentData.push(d);
          }))

        if (d.lottery && !d.media)
          dataPromise.push(this.getListFiles('/app/lottery', 'Loterie').then(d => {
            currentData.push(d);
          }))


        Promise.all(dataPromise).then(d => {
        //  console.log("PROMISE ALL", currentData)
          resolve(currentData)
        })
      })





    })
  }



  getListFiles(path, dataName) {
    return new Promise<any>((resolve, reject) => {
      let dataPromise = [];
      let fileData;

      this.afStorage.storage.ref(path).listAll().then((d) => {
        if (d.items.length > 0) {
          fileData = { name: dataName, children: [] }
          d.items.forEach(elem => {
            dataPromise.push(elem.getDownloadURL().then(url => {
              fileData.children.push({ name: elem.name, url: url })
            }))
          })
        }

        Promise.all(dataPromise).then(d => {
          resolve(fileData)
        })


      })
    })
  }


  ngOnInit(): void {

    this.manageModule().then(d => {
      this.dataSource.data = d


      //console.log(this.dataSource.data)
    })

  }

}
